import axios from '../../bootstrap';

/**
 * Theme
 */
/**
 * @param {string} themecolor
 */
export function getTheme(themecolor) {
    return axios.get(
        `/api/admin/sitetheme/getthemestyle?theme_color=${themecolor}`
    );
}

/**
 * @param {{ fullwidth: string; theme_color: string; theme_css: string; }} objSetting
 */
export function setTheme(objSetting) {
    return axios.post('/api/admin/sitetheme/setthemestyle', objSetting);
}

/**
 * SEO
 */

/**
 * @param {number} slugId
 */
export function getSeoData(slugId) {
    return axios.post('/api/admin/service/seocontent', slugId);
}

/**
 * MENU
 * */

/**
 * @param {{ location: string; title: string; }} objData
 */
export function addMenu(objData) {
    return axios.post('/api/admin/menu/new', objData);
}

/**
 * @param {{ type?: string; menu_id?: string; title?: string | number | string[]; typeL?: string; icon?: any; badge_title?: string | number | string[]; badge_style?: any; target?: string; menu_type?: string | number | string[]; target_id?: string; slug?: string; url?: string | number | string[]; }} objData
 */
export function updateMenu(objData) {
    var axiosRAction,
        type = objData.type;
    switch (type) {
        case 'rename':
            axiosRAction = axios.post('/api/admin/menu/rename', objData);
            break;
        case 'icon':
            axiosRAction = axios.post('/api/admin/menu/icon', objData);
            break;
        case 'badge':
            axiosRAction = axios.post('/api/admin/menu/icon', objData);
            break;
        case 'target':
            axiosRAction = axios.post('/api/admin/menu/target', objData);
            break;
        case 'url':
            axiosRAction = axios.post('/api/admin/menu/url', objData);
            break;
        default:
            break;
    }

    return axiosRAction;
}

/**
 * @param {{ menu_json: any; }} objData
 */
export function saveMenu(objData) {
    return axios.post('/api/admin/menu/savemenu', objData);
}

/**
 * @param {{ type: string; menu_id: any; }} objData
 */
export function deleteMenu(objData) {
    return axios.post('/api/admin/menu/delete', objData);
}
